import { FIELD_TYPES } from 'src/constants/Fields';
// The entity on the BE is named "events", that's why columns are events.xxx

const fundraising = [
  {
    field: 'events.id',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'events.name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'events.slug',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'events.type',
    minWidth: 150,
    type: FIELD_TYPES.eventType,
  },
  {
    field: 'events.goal',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'events.raised',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'events.active',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'events.start_date',
    minWidth: 150,
    type: FIELD_TYPES.datetime,
  },
  {
    field: 'events.end_date',
    minWidth: 150,
    type: FIELD_TYPES.datetime,
  },
  {
    field: 'events.created_at',
    minWidth: 150,
    type: FIELD_TYPES.date,
  },
  {
    field: 'events.updated_at',
    minWidth: 150,
    type: FIELD_TYPES.date,
  },
  {
    field: 'events.deleted_at',
    minWidth: 150,
    type: FIELD_TYPES.date,
    hide_in_search: true,
  },
];

export default fundraising;
